import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { BusinessProvider } from './contexts/BusinessContext';
import { ThemeModeProvider } from './contexts/ThemeModeContext';
import { SettingsDialogProvider } from './contexts/SettingsDialogContext';
import { BrandingProvider } from './contexts/BrandingContext';
import App from './App';

// Use direct env variable references so webpack can replace them at build time
const envOr = (v: string | undefined, fb: string) => (v && v.trim().length > 0 ? v : fb);
const FRONTEND_BASE = envOr(process.env.REACT_APP_FRONTEND_URL as string | undefined, window.location.origin);
const IDENTITY_URL = envOr(process.env.REACT_APP_IDENTITY_URL as string | undefined, 'https://identity.morganruraltech.com.au');


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrandingProvider>
        <BusinessProvider>
          <ThemeModeProvider>
            <SettingsDialogProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </SettingsDialogProvider>
          </ThemeModeProvider>
        </BusinessProvider>
      </BrandingProvider>
    </AuthProvider>
  </React.StrictMode>
);
